import React from 'react';
import { Routes, Route, Outlet, NavLink } from 'react-router-dom';
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import { withAuthenticator, Button } from '@aws-amplify/ui-react';
import awsExports from "./aws-exports.js"
import { Auth } from 'aws-amplify';
import './App.css'
import Customers from "./pages/Customers"
import "primereact/resources/themes/tailwind-light/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";       

Amplify.configure(awsExports);

// yes, I know it's not best practice from a security pov
// but the risk is low as idtoken will expire after 60 minutes
// and the data that will be cridded will be deleted anyway
// it does not automatically flow into any other systems
// as this solution has a low life expectance this is faster to implement
// once these features move to uatnext it will be secured
Amplify.configure({
  API: {
    graphql_headers: async () => {
      const session = await Auth.currentSession();
      return {
        Authorization: session.getIdToken().getJwtToken(),
      };
    },
  },
});

const App = ({user}) => {

  return (
    <>
    <Routes>
      <Route element={<Layout user={user}/>}>
        <Route index element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="*" element={<p>There's nothing here: 404!</p>} />
      </Route>
    </Routes>
    </>
  );
};

const Layout = ({user}) => {
  const style = ({ isActive }) => ({
    fontWeight: isActive ? 'bold' : 'normal',
  });

  async function signOut() {
    try {
        await Auth.signOut();
    } catch (error) {
        console.log('error signing out: ', error);
    }
  }

  return (
    <>
      <h1>TecAlliance Garage Support Tool - Kundendatenpflege-Tool</h1>
      <h2>Hello {user.username}</h2>
      <Button onClick={signOut}>Sign out</Button>
      <nav
        style={{
          borderBottom: 'solid 1px',
          paddingBottom: '1rem',
        }}
      >
      </nav>

      <main style={{ padding: '1rem 0' }}>
        <Outlet/>
      </main>
    </>
  );
};

const Home = () => {
  return (
    <>
      <Customers />  
    </>
  )
};

export default withAuthenticator(App, {
  hideSignUp: true
});